/**
 * @Description:
 * @author WZP
 * @date 2021/8/25
 */

import React from 'react';
import classNames from 'classnames/bind';

import styles from './styles.scss';
import PageContainer from 'containers/en/page-container';
import Section from 'components/section';
import { useTranslation } from 'hooks/use-translation';

const cx = classNames.bind(styles);

function HowWorks(props: Record<string, any>) {
	const { transData } = useTranslation('howItWorks');

	return (
		<PageContainer>
			<div className={cx('tutors')}>
				<div className={cx('banner-block')}>
					<div className={cx('blue-circle', 'banner-top')}></div>
					<div className={cx('tl-circle', 'banner-left')}></div>
					<img loading="lazy" src={transData.freeImg} alt="" className={cx('text')} />
					<img
						loading="lazy"
						src="https://web-data.zmlearn.com/image/g4eYfGvzBnja7BR468Ydgg/banner_works.png"
						alt=""
						className={cx('banner')}
					/>
				</div>
				<div className={cx('tutors-container')}>
					<div className={cx('yel-circle', 'two')}></div>
					<Section>
						{transData.teacherIntro.map((item: { tchImg: string | undefined; title: string | number | boolean | {} | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactNodeArray | React.ReactPortal | null | undefined; desc: any }, index: number) => (
							<div
								className={cx('list', {
									reserve: !!(index % 2),
								})}
								key={index}>
								<div className={cx('icon')}>
									<img loading="lazy" src={item.tchImg} alt="" />
								</div>
								<div className={cx('text')}>
									<div className={cx('tips')}>{index + 1}</div>
									<h2 className={cx('title')}>{item.title} </h2>
									<div className={cx('desc')} dangerouslySetInnerHTML={{ __html: item.desc }} />
								</div>
							</div>
						))}
					</Section>
				</div>
			</div>
		</PageContainer>
	);
}
export default HowWorks;
